import React from "react";
import Navbar from "../../components/base/landing/navbar";
import FooterLanding from "../../components/base/landing/footer";
import Primaria from "../../components/base/landing/primaria";
import WhatsApp from "../../components/base/whatsapp";
import BlogButton from "../../components/base/blog";


const PrimariaPage = () => {
    return (
      <>
        <Navbar />
        <Primaria/>
        <FooterLanding/>
        <BlogButton/>
        <WhatsApp/>
      </>
    );
  };
  
  export default PrimariaPage;